import { Flex, Typography } from "antd";
import type { Icon } from "@phosphor-icons/react";
import { DnaDimensionHeader } from "./DnaDimensionHeader";

export type DnaDimensionRowProps = Readonly<{
  icon: Icon;
  label: string;
  title: string;
  body: string;
}>;

export const DnaDimensionRow = ({
  icon,
  label,
  title,
  body,
}: DnaDimensionRowProps) => (
  <Flex vertical gap={12}>
    <DnaDimensionHeader icon={icon} label={label} title={title} />
    <Typography.Text>{body}</Typography.Text>
  </Flex>
);
